import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import "./field-focus.css";
import "./feed-live-polish.css";
import App from "./App";
import { warmupApi } from "./lib/api";

warmupApi();

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(<App />);
